import React, { useEffect, useState } from 'react';
import './CallHistory.css';
import {
  PhoneDisabled,
  CallReceived,
  CallMade
} from '@mui/icons-material';
import { fetchCallHistory } from '../../API/CommonApi';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const CallHistory = ({ phoneId, contactNo }) => {

  // const safePhone = contactNo.replace(/[^a-zA-Z0-9_\-\.]/g, '');
  console.log("phoneId and contactNo in CallHistory:", phoneId, contactNo); 

  const [loading, setLoading] = useState(true);
  const [callHistoryData, setCallHistoryData] = useState([]);

  async function fetchCallRecords() {
    try {
      const response = await fetchCallHistory(phoneId, contactNo);
      if (!response.ok) {
        throw new Error("Failed to fetch call records");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching call records:", error);
      return [];
    }
  }

  useEffect(() => {
    setLoading(true);
    async function loadRecords() {
      const data = await fetchCallRecords(phoneId, contactNo);
      setCallHistoryData(data);
      setLoading(false);
    }

    loadRecords();
  }, [phoneId, contactNo]);

  return (
    <div className="call-history-container">
      {callHistoryData ? (<ul className="call-list">
        {callHistoryData.map((call, index) => (
          <li key={index} className={`call-item ${call.status}`}>
            <div className="call-icon">
              {(!call.data.duration && call.data.direction === "USER_INITIATED") ? <PhoneDisabled style={{ color: "#ff3b30" }} /> :
               call.data.direction === "USER_INITIATED" ? <CallReceived style={{ color: "#25d366" }} /> :
               <CallMade style={{ color: "#34b7f1" }} /> }
            </div>
            <div className='call-details'>
              <div className="call-status">
                {(!call.data.duration && call.data.direction === "USER_INITIATED") ? "Missed" :
                call.data.direction === "USER_INITIATED" ? "Incoming" : "Outgoing"}
              </div>
              <span className="call-time">{formatTime(call.updated_at)}</span>
            </div>
            {call.data.duration && 
              (<div className="call-details">
                <span className="call-duration">{formatCallDuration(call.data.duration)}</span>
              </div>)
            }
            {(!call.data.duration && call.data.direction === "BUSINESS_INITIATED") && 
              (<div className="call-details">
                <span className="call-duration">did not connect</span>
              </div>)
            }
          </li>
        ))}
      </ul>) : (<p className='caller-name'>No call history available.</p>)}
    </div>
  );
};

function formatTime(timestamp) {
  const dateObj = new Date(timestamp);

  const date = dateObj.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const time = dateObj.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${date}\n${time}`;
}


function formatCallDuration(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSec = seconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else if(minutes > 0) {
    return `${minutes}m ${remainingSec}s`;
  }else {
    return `${seconds}s`
  }
}


export default CallHistory;
